import axios from 'axios';
// import axios from 'more-request/instance';

import config from './config';
import router from '../router/router';

const service = axios.create(config);

function getCookie(name) {
  // 获取指定名称的cookie值
  // (^| )name=([^;]*)(;|$),match[0]为与整个正则表达式匹配的字符串，match[i]为正则表达式捕获数组相匹配的数组；
  const arr = document.cookie.match(new RegExp(`(^| )${name}=([^;]*)(;|$)`));
  if (arr != null) {
    return unescape(arr[2]);
  }
  return null;
}

// POST 传参序列化
service.interceptors.request.use(
  (config) => {
    const token = getCookie('epecToken');
    const headers = {
      'Content-Type': config.headers['Content-Type'] || 'application/json',
      'epec-from': 'WEB_SITE',
      'epec-locale': 'ZH',
    };
    if (token) {
      config.headers = {
        ...headers,
        'epec-sso-token': token,
      };
    } else {
      config.headers = {
        ...headers,
        'epec-sso-token': '',
      };
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
// 返回状态判断
service.interceptors.response.use(
  (res) => {
    if (res.data.code == 401) {
      router.push({ path: '/ssologin' });
      // return
    } else {
      return res.data;
    }
  },
  (error) => {
    if (error.response.status == 401) {
      return;
    }
    return Promise.reject(error);
  }
);

export default service;
